import React, {
  useState,
  useEffect,
  useRef,
  useCallback,
  ReactNode,
  CSSProperties,
} from "react";

/* ============================================================================
   ODSTOUPIT ČI NEODSTOUPIT?  —  webová verze pro Družstevní hlas (bdsr.cz)
   ----------------------------------------------------------------------------
   STRIKTNÍ TYPESCRIPT VERZE ( plné texty )
   ============================================================================ */

// 1. DEFINICE TYPŮ
interface Kapitola {
  id: string;
  nav: string;
}

interface DataInfo {
  brand: string;
  autor: string;
  role: string;
  kapitoly: Kapitola[];
}

interface ZvyraznitBlok {
  popisek?: string;
  zvyraznit?: string[];
  citace: string;
}

type TextBlok = string | ZvyraznitBlok;

interface ExtraItem {
  type: "komunikace" | "dokument" | "poznamka" | string;
  zdroj?: string;
  datum?: string;
  text: string | TextBlok[];
  nadpis?: string;
  meta?: string;
  odkaz?: string;
}

type ExtrasRecord = Record<string, ExtraItem[]>;

// 2. DATA
const DATA: DataInfo = {
  brand: "Družstevní hlas",
  autor: "Zdeněk Mach",
  role: "Člen představenstva BD Stará Role č. 1 (do 31.7.2026)",
  kapitoly: [
    { id: "uvod", nav: "Úvod" },
    { id: "proc", nav: "Proč jsem vstoupil" },
    { id: "duvody", nav: "Hlavní důvody" },
    { id: "duvod1", nav: "Důvod 1" },
    { id: "duvod2", nav: "Důvod 2" },
    { id: "duvod3", nav: "Důvod 3" },
    { id: "plocha", nav: "Pronajatá plocha" },
    { id: "uver", nav: "Míra využití úvěru" },
    { id: "moralka", nav: "Platební morálka" },
    { id: "shrnuti", nav: "Shrnutí" },
    { id: "zaver", nav: "Závěr" },
  ],
};

/* === DOPLŇKY ===================== */
const EXTRAS: ExtrasRecord = {
  duvod2: [
    {
      type: "poznamka",
      nadpis: "Stav k dnešnímu dni",
      text: "Od uložení úkolu uplynulo více než 10 měsíců. Žádné jednání s městem Karlovy Vary o narovnání vlastnického poměru nebylo zahájeno ani zaprotokolováno.",
    },
  ],

  duvod1: [
    {
      type: "dokument",
      nadpis: "Výzva představenstvu ke splnění závazků (čl. 8.1)",
      meta: "datová schránka · 28. 3. 2026",
      text: `Věc: Výzva ke splnění smluvních závazků vyplývajících ze smluv o vstupu do družstva (čl. 8.1) a k naplnění usnesení členské schůze ze dne 23. 6. 2025

Vážení kolegové,

obracím se na Vás tímto dopisem jako člen představenstva Bytového družstva Stará Role č. 1 (dále jen „Družstvo“) s výslovnou výzvou, aby představenstvo bez dalšího odkladu přijalo konkrétní kroky k plnění závazků Družstva vůči členům.

Tento dopis navazuje na můj e-mail ze dne 17. února 2026, ve kterém jsem formálně požádal o zařazení příslušných bodů na program jednání představenstva. Na tuto žádost nebylo do dnešního dne reagováno, a to ani věcným vyjádřením, ani zařazením bodů na program. Tuto skutečnost považuji za závažnou.

I. Smluvní závazek z článku 8.1 smluv o vstupu do družstva

Připomínám, že Družstvo a Město Karlovy Vary jako budoucí pronajímatelé uzavřeli s každým budoucím nájemcem (dnes členem družstva) smlouvu o uzavření budoucí nájemní smlouvy a o vstupu do družstva. Článek 8.1 těchto smluv stanoví:

„Budoucí pronajímatelé se touto smlouvou zavazují, že bez zbytečného odkladu po uplynutí lhůty 20 let ode dne právní moci kolaudačního rozhodnutí na bytové domy zajistí platné rozdělení bytových domů na jednotky podle zák. č. 72/1994 Sb. spolu s příslušnými spoluvlastnickými podíly ke společným částem domu a příslušným zastavěným pozemkům a pozemkům k budově přínáležejícím.“

Dvacetiletá lhůta od právní moci kolaudačního rozhodnutí již uplynula. Závazek „bez zbytečného odkladu“ zajistit rozdělení domů na jednotky je tedy splatný. Představenstvo je povinno činit kroky k jeho splnění.

II. Neplnění usnesení členské schůze ze dne 23. 6. 2025

Členská schůze jako nejvyšší orgán Družstva přijala usnesení, kterým uložila představenstvu dojednat s Městem Karlovy Vary odpovídající převod z majetku města na družstvo v souvislosti s narovnáním stávajícího vlastnického poměru 51 % : 49 %. Od přijetí usnesení uplynulo více než devět měsíců. Představenstvo neučinilo jakýkoliv prokazatelný krok směřující k naplnění tohoto usnesení – neoslovilo Město s konkrétním návrhem.

Usnesení členské schůze je pro představenstvo závazné (§ 706 odst. 2 ZOK). Jeho ignorování je porušením povinnosti členů představenstva.

III. Právní důvody, proč je nutné konat

Pacta sunt servanda. Základním principem českého soukromého práva je zásada, že smlouvy se mají dodržovat. Tento princip je zakotven v § 3 odst. 2 písm. d) občanského zákoníku a představuje základní stavební kámen právní jistoty a důvěry v právní vztahy. Článek 8.1 smluv o vstupu do družstva je platným smluvním závazkem – užívá formulaci „zavazují se“, nikoliv pouhou deklaraci. Družstvo ani Město se tohoto závazku nemohou zbavit pouhým ignorováním.

Vynutitelnost závazku bez smluvní pokuty. Skutečnost, že článek 8.1 nestanoví smluvní pokutu za nesplnění, nemá žádný vliv na vynutitelnost závazku. Smluvní pokuta je pouze zajišťovacím instrumentem (§ 2048 OZ), nikoliv podmínkou platnosti či vynutitelnosti závazku. V případě nesplnění má každý člen družstva k dispozici žalobu na nahrazení projevu vůle i nárok na náhradu škody (§ 2913 OZ), včetně rozdílu tržní hodnoty bytu v osobním vlastnictví oproti hodnotě družstevního podílu nebo náhrady nákladů řízení.

Péče řádného hospodáře. Členové představenstva jsou povinni jednat s péčí řádného hospodáře (§ 159 odst. 1 OZ ve spojení s § 51 ZOK). Tato povinnost zahrnuje nejen aktivní správu majetku, ale i plnění smluvních závazků a usnesení členské schůze. Zbytečné oddalování či pasivita při plnění splatného závazku zakládá osobní odpovědnost členů představenstva za škodu způsobenou členům družstva.

Přednost smluvního závazku před usnesením členské schůze. Předjímám argument, že usnesení členské schůze stanoví pořadí „až následně“ a že je tedy třeba nejprve narovnat vlastnické poměry a teprve poté provést rozdělení na jednotky. Tento argument považuji za právně nesprávný, a to z následujících důvodů:

Za prvé, smluvní závazek z článku 8.1 má přednost před usnesením členské schůze. Právo každého člena na rozdělení domů na jednotky vyplývá z jeho individuální smlouvy uzavřené při vstupu do družstva. Usnesení členské schůze je interním korporátním aktem pouze jedné ze smluvních stran. Ke změně smlouvy je třeba dohody všech smluvních stran, nikoliv majoritního hlasování uvnitř jedné z nich.

Za druhé, lpění na výkladu „až následně“ je nepřiměřeným zkrácením práv členů dle § 212 odst. 2 OZ. Narovnání vlastnických poměrů s Městem nemá žádný stanovený termín – může trvat měsíce, roky, nebo k němu nemusí dojít vůbec. Vázat splnění splatného smluvního závazku na nejistou budoucí událost bez termínu je ze své podstaty nepřiměřené, zvláště když každý den prodlení způsobuje členům reálnou majetkovou újmu a článek 8.1 výslovně stanoví povinnost „bez zbytečného odkladu“.

Za třetí, prohlášení vlastníka není totéž co převod bytů na členy. Článek 8.1 ukládá „zajistit platné rozdělení bytových domů na jednotky“ – to je prohlášení vlastníka dle § 1166 OZ. Prohlášení pouze vymezuje jednotky a společné části, samo o sobě nepřevádí vlastnictví na členy. Usnesení členské schůze říká, že „převod proběhne až následně“ – ale prohlášení vlastníka převod není. Provedení prohlášení vlastníka tedy usnesení neporušuje, a to ani při jeho nejstriktnějším výkladu.

Za čtvrté, Město Karlovy Vary není usnesením členské schůze vázáno. Město je spoluzavázáno z článku 8.1 a je spoluvlastníkem domů (49 %). Usnesení členské schůze je interním aktem cizí právnické osoby a Město jím není dotčeno. Pokud Město projeví ochotu součinit při prohlášení vlastníka, nemůže tomu usnesení členské schůze Družstva bránit.

Z výše uvedeného vyplývá, že jako člen představenstva mám nejen právo, ale povinnost upřednostnit plnění smluvního závazku z článku 8.1 a požadovat, aby představenstvo ve spolupráci s Městem provedlo prohlášení vlastníka bez dalšího odkladu, a to bez ohledu na stav jednání o narovnání vlastnických poměrů.

IV. Morální a lidský rozměr věci

Nad rámec právních argumentů považuji za důležité připomenout, co závazek z článku 8.1 pro naše členy skutečně znamená.

Naši členové vstupovali do Družstva s důvěrou, že jim bude umožněno získat byty do osobního vlastnictví. Tato důvěra byla založena na konkrétním smluvním příslibu. Lidé investovali své úspory, splácí členské vklady a po dvacet let plnili své závazky vůči Družstvu. Nyní je čas, aby Družstvo splnilo svůj závazek vůči nim.

Byty v osobním vlastnictví mají na trhu výrazně vyšší hodnotu než družstevní podíly. Každý měsíc prodlení způsobuje našim členům reálnou majetkovou újmu – nemohou svůj byt volně prodat za tržní cenu, nemohou jej využít k zajištění hypotéky, nemají plnou právní jistotu svého bydlení. Někteří naši členové jsou senioři, kteří chtějí mít své majetkové záležitosti vyřešené. Jiní potřebují byt převést z důvodu rodinných změn. Všichni si zaslouží, abychom jako představenstvo jednali v jejich zájmu, nikoliv věc odkládali.

Jako člen představenstva cítím osobní odpovědnost vůči lidem, kteří nám svěřili správu svého bydlení. Slíbit něco smlouvou a po dvaceti letech to nesplnit – to není jen právní problém, to je otázka slušnosti a důvěryhodnosti.

V. Konkrétní požadavky

Na základě výše uvedeného požaduji, aby představenstvo:

1. Bezodkladně zařadilo na program jednání představenstva bod „Projednání způsobu naplnění povinnosti Družstva a Města vyplývající z článku 8.1 smluv o vstupu do družstva“ a bod „Projednání způsobu naplnění usnesení členské schůze ze dne 23. 6. 2025 o jednání s Městem“.

2. Bez zbytečného odkladu zahájilo jednání s Městem Karlovy Vary o narovnání vlastnických poměrů v souladu s usnesením členské schůze a začalo činit kroky k naplnění usnesení členské schůze.

3. Ve spolupráci s Městem Karlovy Vary jakožto spoluvlastníkem zahájilo bez zbytečného odkladu přípravu prohlášení vlastníka (což zahrnuje zejména zadání pasportizace objektů a vyhotovení schematických půdorysů všech podlaží oprávněnou osobou, definici společných částí a stanovení pravidel pro správu domu tak, aby mohl být podán návrh na vklad do katastru nemovitostí) dle § 1166 zákona č. 89/2012 Sb., občanský zákoník, a začalo bez zbytečného odkladu činit kroky k naplnění smluvního závazku z článku 8.1 smlouvy o vstupu do družstva.

VI. Upozornění na důsledky další nečinnosti

Pokud představenstvo na tuto výzvu v přiměřené lhůtě nereaguje nebo nepřijme odpovídající opatření a nezačne činit kroky k naplnění usnesení členské schůze a svého smluvního závazku:

a) podám podnět kontrolní komisi Družstva k prošetření nečinnosti představenstva,
b) zvážím kontaktování Města Karlovy Vary s žádostí o naplnění smluvního závazku z článku 8.1 smlouvy o vstupu do družstva,
c) zvážím podání výzvy k plnění dle o. s. ř. adresované Družstvu i Městu Karlovy Vary,
d) zvážím podání žaloby na nahrazení projevu vůle dle § 161 odst. 3 o. s. ř.

Tyto kroky nechci činit a věřím, že nejsou nutné. Věřím, že představenstvo nalezne vůli jednat v zájmu členů družstva, jak mu ukládá zákon, stanovy, smlouvy i obyčejná lidská slušnost.

Žádám, aby tento dopis byl založen do dokumentace představenstva a aby byl bezodkladně projednán na schůzi představenstva družstva.

S úctou
Zdeněk Mach, člen představenstva BD Stará Role č. 1

Na vědomí: Kontrolní komise BD Stará Role č. 1`,
    },
    {
      type: "dokument",
      nadpis: "Podnět kontrolní komisi",
      meta: "12. 5. 2026",
      text: `Věc: Podnět k projednání stavu plnění závazků Družstva z článku 8.1 a 1.5 smluv o vstupu do družstva a usnesení členské schůze ze dne 23. 6. 2025

Vážení členové kontrolní komise,

obracím se na Vás jako člen představenstva Bytového družstva Stará Role č. 1 (dále jen „Družstvo“) a současně i jako člen Družstva s podnětem týkajícím se stavu plnění závazků Družstva vůči jeho členům. Věřím, že kontrolní komise jako orgán určený k ochraně zájmů členů může k řešení této věci přispět.

I. Shrnutí smluvního závazku Družstva

Při vstupu do Družstva uzavřel každý budoucí nájemce s Družstvem a Městem Karlovy Vary smlouvu o uzavření budoucí nájemní smlouvy a o vstupu do družstva. Tato smlouva obsahuje dvě klíčová ustanovení, která jsou pro tento podnět podstatná.

Článek 1.5 smlouvy stanoví:
„Strany této smlouvy deklarují společný záměr v budoucnu uskutečnit vlastnický převod bytové jednotky, k ní neoddělitelně náležejícího a podle ustanovení § 8 odst. 2 zákona čís.: 72/1994 Sb. určeného spoluvlastnického podílu na společných částech domu, jakož i na pozemcích, na nichž dům stojí, tedy té bytové jednotky, s níž je nyní spojeno právo nájmu bytu svědčící ve prospěch budoucího nájemce a označené v půdorysech domu, tvořících přílohu č. 5 této smlouvy, a to z podílového spoluvlastnictví Družstva a Města do výlučného vlastnictví budoucího nájemce.“

Článek 8.1 smlouvy pak stanoví konkrétní povinnost a lhůtu:
„Budoucí pronajímatelé se touto smlouvou zavazují, že bez zbytečného odkladu po uplynutí lhůty 20 let ode dne právní moci kolaudačního rozhodnutí na bytové domy zajistí platné rozdělení bytových domů na jednotky podle zák. č. 72/1994 Sb. spolu s příslušnými spoluvlastnickými podíly ke společným částem domu a příslušným zastavěným pozemkům a pozemkům k budově přínáležejícím.“

Obě ustanovení společně vyjádřila vůli smluvních stran od samého počátku: článek 1.5 deklaruje společný záměr převést bytové jednotky do výlučného vlastnictví členů, článek 8.1 pak stanovuje konkrétní povinnost a časový rámec. Dvacetiletá lhůta od právní moci kolaudačního rozhodnutí již uplynula.

II. Usnesení členské schůze ze dne 23. 6. 2025

Členská schůze jako nejvyšší orgán Družstva přijala usnesení, kterým uložila představenstvu dojednat s Městem Karlovy Vary odpovídající převod z majetku města na družstvo v souvislosti s narovnáním stávajícího vlastnického poměru 51 % : 49 %.

Usnesení členské schůze je pro představenstvo závazné (§ 706 odst. 2 ZOK). Od přijetí tohoto usnesení uplynulo více než deset měsíců. Pokud je mi známo, představenstvo dosud neoslovilo Město Karlovy Vary se žádným návrhem na narovnání vlastnických poměrů a neučinilo jiný prokazatelný krok směřující k naplnění tohoto usnesení.

III. Dosavadní průběh

Dne 5. 1. 2026 jsem datovou schránkou požádal představenstvo Družstva o projednání příslušných bodů na jednání představenstva. Na tuto výzvu nebylo reagováno.

Dne 17. 2. 2026 jsem e-mailem požádal Družstvo o zařazení příslušných bodů na program jednání představenstva. Kopie byla zaslána i na e-mail kontrolní komise. Na tuto výzvu nebylo reagováno.

Dne 28. 3. 2026 jsem datovou schránkou představenstvu adresoval výzvu ke splnění smluvních závazků z článku 8.1 a k naplnění usnesení členské schůze. Kopie byla zaslána i na e-mail kontrolní komise. Na tuto výzvu nebylo reagováno.

K dnešnímu dni nedošlo ze strany představenstva k žádné reakci na výše uvedené podněty – požadované body nebyly zařazeny na program jednání, nebylo poskytnuto věcné vyjádření a pokud je mi známo, nebyly učiněny žádné kroky směřující k naplnění usnesení členské schůze ani ke splnění smluvního závazku.

IV. Důvod podnětu

Jako člen představenstva jsem vyčerpal možnosti, které mám k dispozici v rámci představenstva, a proto se obracím na kontrolní komisi, která je dle § 724 odst. 1 ZOK oprávněna kontrolovat činnost družstva a projednávat podněty členů.

Považuji za důležité na celou situaci upozornit. Členové družstva vstupovali do Družstva s důvěrou, že jim bude umožněno získat byty do osobního vlastnictví – článek 1.5 výslovně deklaruje společný záměr převést bytové jednotky do výlučného vlastnictví nájemců a článek 8.1 k tomu stanoví konkrétní povinnost a lhůtu. Lidé investovali své úspory, po dvacet let plnili své závazky a oprávněně očekávají, že Družstvo splní svůj závazek vůči nim.

V. Závěrečná prosba

Žádám kontrolní komisi, aby se věcí zabývala a posoudila, zda jsou činěny dostatečné kroky k naplnění smluvních závazků vyplývajících z článku 1.5 a 8.1 smluv o vstupu do družstva a usnesení členské schůze ze dne 23. 6. 2025, a sdělila mi své stanovisko jako členu družstva.

Děkuji Vám za pozornost a čas věnovaný této věci.

S úctou
Mgr. Zdeněk Mach`,
    },
  ],

  duvod3: [
    {
      type: "dokument",
      nadpis: "Přijaté usnesení členské schůze — 3. varianta",
      meta: "náhradní členská schůze · 28. 11. 2023",
      text: [
        `USNESENÍ (bod Ad 4 zápisu)\n\n„Členská schůze ukládá představenstvu provést konečný rozpočet nákladů z výstavby domů na členy družstva podle ‚3. varianty' zveřejněného a zde diskutovaného návrhu."\n\nPřijato na náhradní členské schůzi dne 28. 11. 2023 (svolané dle § 647 ZOK, usnášeníschopné dle § 648 odst. 1 ZOK bez ohledu na počet přítomných). Výsledek 2. kola hlasování: pro 3. variantu 29 hlasů, pro 1. variantu 7 hlasů, zdrželo se 11 hlasů.`,
        `———\n\n3. VARIANTA\n(z přílohy „Návrh konečného rozpočtu nákladů z výstavby domů na členy družstva")\n\nPrávní důvod: § 744 odst. 1 ZOK`,
        {
          popisek: "§ 744 odst. 1 ZOK",
          zvyraznit: ["Členové", "hradí", "náklady bytového družstva"],
          citace:
            "Členové, kteří jsou nájemci družstevních bytů, hradí v nájemném bytovému družstvu pouze účelně vynaložené náklady bytového družstva vzniklé při správě těchto družstevních bytů, včetně nákladů na opravy, modernizace a rekonstrukce domů, ve kterých se nacházejí, a příspěvků na tvorbu dlouhodobého finančního zdroje na opravy a investice těchto družstevních bytů.",
        },
        `Popis: Počínaje rokem 2024 družstvo zcela přestane využívat své právo plynoucí ze smluv na výběr dalšího členského vkladu, a tudíž i jeho splátek. Zároveň družstvo celý koncept výběru peněz od členů na úhradu veškerých svých závazků z výstavby domů založí na ustanovení § 744 odst. 1 zákona o obchodních korporacích. Nový koncept se bude nerozdílně vztahovat na všechny členy, přitom budou zohledněny následující aspekty:

•  pronajatá plocha (souhrnně bytu a případné garáže či sklepů),
•  míra využití družstevního úvěru (k odloženému či postupnému plnění vkladové povinnosti nebo dlouhodobého finančního zdroje),
•  platební morálka (plnění vkladové povinnosti nebo dlouhodobého finančního zdroje).

Na jistinu (tj. předmět závazku z výstavby) a nevyhnutelné příslušenství se uplatní jen pronajatá plocha; na vyhnutelné příslušenství (které lze eliminovat platbou člena) se uplatní všechny tři aspekty. Technicky bude výběr peněz prováděn měsíčními platbami v rámci „družstevního nájmu" přes IKON.`,
      ],
    },
  ],

  shrnuti: [
    {
      type: "dokument",
      nadpis:
        `Nesouhlas s vypuštěním aspektu „platební morálka"`,
      meta: "představenstvu a kontrolní komisi · datová schránka · 29. 5. 2026",
      text: `
Věc: Nesouhlas s vypuštěním aspektu „platební morálka" při provádění usnesení členské schůze ze dne 28. 11. 2023 a návrh na předložení věci členské schůzi k novému rozhodnutí

Vážení členové představenstva, vážení členové kontrolní komise,

dovoluji si tímto písemně vyjádřit svůj postoj k způsobu provádění usnesení náhradní členské schůze našeho družstva konané dne 28. 11. 2023, kterým členská schůze uložila představenstvu provést konečný rozpočet nákladů z výstavby domů na členy družstva podle „3. varianty" zveřejněného a na schůzi diskutovaného návrhu (dále jen „usnesení").

„3. varianta", která tvoří přílohu zápisu a o níž se hlasovalo, ve svém popisu výslovně stanoví, že nový koncept výběru peněz od členů zohlední tři aspekty: (i) pronajatou plochu, (ii) míru využití družstevního úvěru a (iii) platební morálku (plnění vkladové povinnosti, resp. dlouhodobého finančního zdroje). Podle schváleného znění se na vyhnutelné příslušenství úvěru, které lze eliminovat platbou člena, mají uplatnit všechny tři uvedené aspekty.

Na společném jednání představenstva a kontrolní komise se předseda představenstva vyjádřil v tom smyslu, že aspekt „platební morálka" nebude do implementace usnesení členské schůze zahrnut, a to s odůvodněním, že jeho zohlednění je komplikované (tedy z důvodu technické a datové náročnosti, nikoli pro tvrzenou právní vadu tohoto aspektu).

S tímto postupem zásadně nesouhlasím, a to z následujících důvodů.

1. Představenstvo je vázáno obsahem usnesení členské schůze. Podle § 706 odst. 2 zákona č. 90/2012 Sb., o obchodních korporacích (dále jen „ZOK"), platí, že „představenstvo plní usnesení členské schůze, není-li v rozporu s právními předpisy". Zákon tedy připouští jedinou výjimku z povinnosti usnesení splnit – rozpor usnesení s právními předpisy. Technická či datová náročnost provedení („je to komplikované") takovou zákonnou výjimkou není. Vzhledem k tomu, že předseda sám netvrdí právní vadu aspektu „platební morálka", není pro jeho vypuštění zákonný důvod a představenstvo je povinno usnesení splnit v celém schváleném rozsahu.

2. Vypuštění jednoho ze tří schválených aspektů je věcnou změnou usnesení, nikoli jeho technickým provedením. Členská schůze neuložila představenstvu volný úkol, nýbrž provedení rozpočtu podle konkrétního návrhu s definovaným obsahem. Prostor pro uvážení má představenstvo pouze ohledně způsobu provedení (volba výpočetního postupu, harmonogram, forma vyúčtování), nikoli ohledně obsahu toho, co bylo schváleno. Odstranění jedné ze tří závazných proměnných mění výslednou alokaci nákladů mezi jednotlivé členy, a jde proto o věcný zásah do obsahu usnesení, k němuž představenstvo není oprávněno.

3. Obsah usnesení může změnit pouze členská schůze. Usnesení členské schůze je právním jednáním družstva (§ 45 ZOK ve spojení s § 545 a násl. občanského zákoníku). Změnit, zrušit nebo zúžit projev vůle učiněný nejvyšším orgánem může zásadně jen tentýž orgán novým usnesením. Žádné ustanovení ZOK neopravňuje představenstvo k tomu, aby usnesení členské schůze samo věcně modifikovalo.

4. Je-li provedení skutečně obtížné, je správným postupem předložit věc členské schůzi. Pokud představenstvo dospělo k závěru, že zohlednění aspektu „platební morálka" je natolik náročné, že je obtížně proveditelné, není řešením tento aspekt jednostranně vypustit, nýbrž dát členské schůzi příležitost znovu rozhodnout – tedy předložit jí věc k tomu, aby původní metodiku buď potvrdila, nebo ji vědomě upravila (například zjednodušila či aspekt „platební morálka" z metodiky výslovně vypustila). Pouze tak zůstane zachována působnost nejvyššího orgánu a legitimita výsledného rozpočtu vůči členům.

5. Riziko spojené s jednostranným vypuštěním aspektu. Provede-li představenstvo usnesení v rozporu s jeho schváleným obsahem, vystavuje se riziku, že takový postup bude posouzen jako porušení povinnosti jednat s péčí řádného hospodáře (§ 159 občanského zákoníku, § 51 a násl. ZOK), a výsledný rozpočet bude postrádat řádný podklad a bude napadnutelný ze strany dotčených členů. Tomuto riziku se lze vyhnout právě tím, že věc bude předložena členské schůzi.

Na základě výše uvedeného navrhuji a žádám, aby představenstvo:

a) provedlo usnesení členské schůze ze dne 28. 11. 2023 v celém jeho schváleném rozsahu, tj. včetně aspektu „platební morálka"; není-li to představenstvo schopno zajistit,

b) předložilo věc členské schůzi k novému rozhodnutí o metodice rozpočtu (k jejímu potvrzení, úpravě nebo vědomému zúžení) a za tím účelem zařadilo odpovídající bod na program nejbližší vhodné členské schůze;

c) zaprotokolovalo tento můj nesouhlas s vypuštěním aspektu „platební morálka" do zápisu z jednání představenstva.

Současně tímto žádám kontrolní komisi družstva, aby v rámci své působnosti podle § 715 zákona o obchodních korporacích dohlédla na to, že postup představenstva při provádění usnesení členské schůze ze dne 28. 11. 2023 bude v souladu s právními předpisy a stanovami družstva, a aby v případě zjištěného rozporu vyzvala představenstvo a dohlédla na zjednání nápravy.

Svůj postoj uvádím v zájmu řádného a zákonného postupu družstva a ochrany práv jeho členů. Jsem připraven věc dále projednat a poskytnout součinnost při přípravě podkladů pro členskou schůzi.

`,
    },
  ],
};

const T: Record<string, string> = {
  green: "#1b4d3e",
  greenDeep: "#143a2e",
  greenSoft: "#e8efe9",
  gold: "#c8a45c",
  goldSoft: "#f3ead7",
  paper: "#faf7f0",
  card: "#ffffff",
  ink: "#22272e",
  body: "#3c4651",
  muted: "#7a8089",
  line: "#e6e1d6",
  red: "#a8392c",
  redSoft: "#f6e7e3",
  ok: "#2e7d52",
  okSoft: "#e7f1ea",
};

const HEAD = "'Playfair Display', Georgia, serif";
const BODY = "'Source Serif 4', Georgia, serif";
const SANS = "'Source Sans 3', system-ui, sans-serif";

/* ----------------------------- doplňky UI ----------------------------- */

interface MetaConfig {
  label: string;
  icon: string;
  color: string;
}

function Extra({ d }: { d: ExtraItem }) {
  const [open, setOpen] = useState<boolean>(false);

  const mapMeta: Record<string, MetaConfig> = {
    komunikace: {
      label: "Z komunikace v představenstvu",
      icon: "✉",
      color: T.green,
    },
    dokument: { label: "Dokument", icon: "📄", color: T.gold },
    poznamka: { label: "Doplňující poznámka", icon: "✎", color: T.green },
  };
  const meta: MetaConfig = mapMeta[d.type] || {
    label: "Doplněk",
    icon: "•",
    color: T.green,
  };

  const head = d.nadpis || (d.zdroj ? d.zdroj : meta.label);

  return (
    <div
      style={{
        border: `1px solid ${T.line}`,
        borderLeft: `3px solid ${meta.color}`,
        borderRadius: 10,
        background: "#fff",
        marginTop: 12,
        overflow: "hidden",
      }}
    >
      <button
        onClick={() => setOpen((o) => !o)}
        style={{
          all: "unset",
          boxSizing: "border-box",
          cursor: "pointer",
          width: "100%",
          display: "flex",
          alignItems: "center",
          gap: 12,
          padding: "14px 16px",
          minHeight: 52,
        }}
      >
        <span style={{ fontSize: 18, lineHeight: 1, flexShrink: 0 }}>
          {meta.icon}
        </span>
        <span style={{ flex: 1, minWidth: 0 }}>
          <span
            style={{
              display: "block",
              fontFamily: SANS,
              fontSize: 11,
              letterSpacing: 0.6,
              textTransform: "uppercase",
              color: meta.color,
              fontWeight: 700,
            }}
          >
            {meta.label}
            {d.datum ? ` · ${d.datum}` : ""}
            {d.meta ? ` · ${d.meta}` : ""}
          </span>
          <span
            style={{
              display: "block",
              fontFamily: SANS,
              fontWeight: 600,
              color: T.ink,
              fontSize: 15,
              marginTop: 2,
            }}
          >
            {head}
          </span>
        </span>
        <span
          style={{
            fontFamily: SANS,
            color: T.muted,
            fontSize: 13,
            flexShrink: 0,
          }}
        >
          {open ? "Skrýt" : "Rozbalit"}
        </span>
      </button>
      {open && (
        <div style={{ padding: "0 16px 16px 16px" }}>
          {d.type === "komunikace" ? (
            <blockquote
              style={{
                margin: 0,
                paddingLeft: 14,
                borderLeft: `2px solid ${T.line}`,
                fontStyle: "italic",
                color: T.body,
                lineHeight: 1.6,
              }}
            >
              {d.text as string}
            </blockquote>
          ) : Array.isArray(d.text) ? (
            <div style={{ color: T.body, lineHeight: 1.65 }}>
              {d.text.map((blok: TextBlok, i: number) =>
                typeof blok === "string" ? (
                  <div
                    key={i}
                    style={{ whiteSpace: "pre-wrap", marginBottom: 12 }}
                  >
                    {blok}
                  </div>
                ) : (
                  <blockquote
                    key={i}
                    style={{
                      margin: "0 0 14px",
                      padding: "12px 16px",
                      background: T.greenSoft,
                      borderLeft: `3px solid ${T.green}`,
                      borderRadius: 8,
                      fontStyle: "italic",
                      lineHeight: 1.7,
                    }}
                  >
                    {blok.popisek && (
                      <div
                        style={{
                          fontFamily: SANS,
                          fontStyle: "normal",
                          fontSize: 11.5,
                          letterSpacing: 0.6,
                          textTransform: "uppercase",
                          color: T.green,
                          fontWeight: 700,
                          marginBottom: 6,
                        }}
                      >
                        {blok.popisek}
                      </div>
                    )}
                    „{zvyrazni(blok.citace, blok.zvyraznit)}“
                  </blockquote>
                )
              )}
            </div>
          ) : (
            <div
              style={{
                color: T.body,
                lineHeight: 1.65,
                whiteSpace: "pre-wrap",
              }}
            >
              {d.text}
            </div>
          )}
          {d.odkaz && (
            <a
              href={d.odkaz}
              target="_blank"
              rel="noreferrer"
              style={{
                fontFamily: SANS,
                display: "inline-block",
                marginTop: 12,
                color: T.green,
                fontWeight: 600,
                fontSize: 14,
              }}
            >
              Otevřít dokument →
            </a>
          )}
        </div>
      )}
    </div>
  );
}

function Extras({ id }: { id: string }) {
  const list = EXTRAS[id];
  if (!list || !list.length) return null;
  return (
    <div style={{ marginTop: 22 }}>
      {list.map((d: ExtraItem, i: number) => (
        <Extra key={i} d={d} />
      ))}
    </div>
  );
}

/* ----------------------------- stavební prvky ----------------------------- */
const Kicker = ({
  n,
  children,
}: {
  n?: number | string;
  children: ReactNode;
}) => (
  <div
    style={{
      fontFamily: SANS,
      display: "flex",
      alignItems: "center",
      gap: 12,
      marginBottom: 14,
    }}
  >
    {n && (
      <span
        style={{
          fontFamily: HEAD,
          fontWeight: 800,
          color: T.gold,
          fontSize: 30,
          lineHeight: 1,
        }}
      >
        {String(n).padStart(2, "0")}
      </span>
    )}
    <span
      style={{
        fontSize: 12.5,
        letterSpacing: 1.4,
        textTransform: "uppercase",
        color: T.muted,
        fontWeight: 700,
      }}
    >
      {children}
    </span>
  </div>
);

const H = ({ children }: { children: ReactNode }) => (
  <h2
    style={{
      fontFamily: HEAD,
      fontWeight: 700,
      color: T.ink,
      fontSize: "clamp(1.7rem, 6vw, 2.4rem)",
      lineHeight: 1.12,
      margin: "0 0 18px",
    }}
  >
    {children}
  </h2>
);

const P = ({
  children,
  style,
}: {
  children: ReactNode;
  style?: CSSProperties;
}) => (
  <p
    style={{
      fontSize: "clamp(1.02rem, 4.2vw, 1.15rem)",
      lineHeight: 1.65,
      color: T.body,
      margin: "0 0 1em",
      ...style,
    }}
  >
    {children}
  </p>
);

const Callout = ({
  children,
  tone = "neutral",
}: {
  children: ReactNode;
  tone?: "neutral" | "danger" | "note";
}) => {
  const map: Record<string, { bg: string; br: string; c: string }> = {
    neutral: { bg: T.greenSoft, br: T.green, c: T.body },
    danger: { bg: T.redSoft, br: T.red, c: T.red },
    note: { bg: "#f7f3ea", br: T.gold, c: T.body },
  };
  const activeTone = map[tone] || map.neutral;
  return (
    <div
      style={{
        background: activeTone.bg,
        borderLeft: `4px solid ${activeTone.br}`,
        borderRadius: 10,
        padding: "16px 18px",
        color: activeTone.c,
        lineHeight: 1.6,
        fontSize: "1.02rem",
      }}
    >
      {children}
    </div>
  );
};

const Law = ({ children }: { children: ReactNode }) => (
  <p
    style={{
      fontFamily: SANS,
      fontStyle: "italic",
      color: T.muted,
      fontSize: 14,
      marginTop: 16,
      lineHeight: 1.5,
    }}
  >
    {children}
  </p>
);

const Mark = ({ children }: { children: ReactNode }) => (
  <mark
    style={{
      background: T.goldSoft,
      color: T.greenDeep,
      fontWeight: 600,
      fontStyle: "normal",
      padding: "0 .12em",
      borderRadius: 3,
      boxDecorationBreak: "clone",
      WebkitBoxDecorationBreak: "clone" as any,
    }}
  >
    {children}
  </mark>
);

function zvyrazni(text: string, faze?: string[]): ReactNode[] | string {
  if (!faze || !faze.length) return text;
  const esc = faze.map((p) => p.replace(/[.*+?^${}()|[\]\\]/g, "\\$&"));
  const re = new RegExp("(" + esc.join("|") + ")");
  return text
    .split(re)
    .map((part, i) =>
      faze.includes(part) ? <Mark key={i}>{part}</Mark> : part
    );
}

function Section({
  id,
  dark,
  children,
  max = 720,
}: {
  id: string;
  dark?: boolean;
  children: ReactNode;
  max?: number;
}) {
  const ref = useRef<HTMLElement>(null);
  const [seen, setSeen] = useState<boolean>(false);
  useEffect(() => {
    const el = ref.current;
    if (!el) return;

    const io = new IntersectionObserver(
      (entries) => {
        if (entries[0].isIntersecting) {
          setSeen(true);
          io.disconnect();
        }
      },
      { threshold: 0.12 }
    );
    io.observe(el);
    return () => io.disconnect();
  }, []);
  return (
    <section
      id={id}
      ref={ref}
      style={{
        background: dark ? T.green : "transparent",
        color: dark ? "#fff" : T.body,
        padding: "clamp(56px, 12vw, 110px) 22px",
        position: "relative",
      }}
    >
      <div
        style={{
          maxWidth: max,
          margin: "0 auto",
          opacity: seen ? 1 : 0,
          transform: seen ? "none" : "translateY(26px)",
          transition:
            "opacity .7s ease, transform .7s cubic-bezier(.2,.7,.3,1)",
        }}
      >
        {children}
      </div>
    </section>
  );
}

/* ============================== STRÁNKA ============================== */
export default function App() {
  const [progress, setProgress] = useState<number>(0);
  const [active, setActive] = useState<string>("uvod");
  const [menu, setMenu] = useState<boolean>(false);

  useEffect(() => {
    const onScroll = () => {
      const h = document.documentElement;
      const max = h.scrollHeight - h.clientHeight;
      setProgress(max > 0 ? (h.scrollTop / max) * 100 : 0);
      let cur = DATA.kapitoly[0].id;
      for (const k of DATA.kapitoly) {
        const el = document.getElementById(k.id);
        if (el && el.getBoundingClientRect().top <= h.clientHeight * 0.4)
          cur = k.id;
      }
      setActive(cur);
    };
    window.addEventListener("scroll", onScroll, { passive: true });
    onScroll();
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  const goto = useCallback((id: string) => {
    setMenu(false);
    document
      .getElementById(id)
      ?.scrollIntoView({ behavior: "smooth", block: "start" });
  }, []);

  return (
    <div
      style={{
        fontFamily: BODY,
        background: T.paper,
        color: T.body,
        minHeight: "100vh",
      }}
    >
      <style>{`
        @import url('https://fonts.googleapis.com/css2?family=Playfair+Display:ital,wght@0,500;0,700;0,800;1,500&family=Source+Serif+4:ital,opsz,wght@0,8..60,400;0,8..60,600;1,8..60,400&family=Source+Sans+3:wght@400;600;700&display=swap');
        * { box-sizing: border-box; }
        html { scroll-behavior: smooth; -webkit-text-size-adjust: 100%; }
        body { margin: 0; overflow-x: hidden; }
        a { -webkit-tap-highlight-color: transparent; }
        .tocItem { transition: color .2s; }
        .tocItem:hover { color: ${T.gold}; }
        .menuLink { transition: background .15s; }
        .menuLink:active { background: ${T.greenSoft}; }
        @media (min-width: px){ .toc { display:flex !important; } .menuBtn{ display:none !important; } }
        .rozborIn { animation: rozbor .35s ease; }
        @keyframes rozbor { from { opacity:0; transform: translateY(-6px); } to { opacity:1; transform:none; } }
      `}</style>

      {/* progres + horní lišta */}
      <div
        style={{
          position: "fixed",
          top: 0,
          left: 0,
          right: 0,
          height: 3,
          background: "rgba(0,0,0,.08)",
          zIndex: 50,
        }}
      >
        <div
          style={{
            height: "100%",
            width: `${progress}%`,
            background: T.gold,
            transition: "width .1s linear",
          }}
        />
      </div>

      <header
        style={{
          position: "fixed",
          top: 3,
          left: 0,
          right: 0,
          height: 54,
          zIndex: 49,
          display: "flex",
          alignItems: "center",
          justifyContent: "space-between",
          padding: "0 18px",
          background: "rgba(250,247,240,.86)",
          backdropFilter: "blur(10px)",
          borderBottom: `1px solid ${T.line}`,
        }}
      >
        <button
          onClick={() => goto("uvod")}
          style={{
            all: "unset",
            cursor: "pointer",
            display: "flex",
            alignItems: "center",
            gap: 9,
          }}
        >
          <span
            style={{
              width: 22,
              height: 22,
              borderRadius: 5,
              background: T.green,
              display: "inline-block",
              position: "relative",
            }}
          >
            <span
              style={{
                position: "absolute",
                inset: 5,
                borderRadius: 2,
                border: `1.5px solid ${T.gold}`,
              }}
            />
          </span>
          <span
            style={{
              fontFamily: HEAD,
              fontWeight: 700,
              color: T.green,
              fontSize: 17,
              letterSpacing: 0.2,
            }}
          >
            {DATA.brand}
          </span>
        </button>

        <nav
          className="toc"
          style={{ display: "none", gap: 18, fontFamily: SANS, fontSize: 13.5 }}
        >
          {DATA.kapitoly
            .filter((k) => k.id !== "uvod")
            .map((k) => (
              <span
                key={k.id}
                className="tocItem"
                onClick={() => goto(k.id)}
                style={{
                  cursor: "pointer",
                  color: active === k.id ? T.gold : T.muted,
                  fontWeight: active === k.id ? 700 : 500,
                }}
              >
                {k.nav}
              </span>
            ))}
        </nav>

        <button
          className="menuBtn"
          onClick={() => setMenu((m) => !m)}
          aria-label="Menu"
          style={{
            all: "unset",
            cursor: "pointer",
            fontFamily: SANS,
            color: T.green,
            fontWeight: 700,
            fontSize: 14,
            padding: "8px 6px",
            display: "flex",
            alignItems: "center",
            gap: 7,
          }}
        >
          {menu ? "Zavřít ✕" : "Obsah ☰"}
        </button>
      </header>

      {menu && (
        <div
          style={{
            position: "fixed",
            top: 57,
            left: 0,
            right: 0,
            bottom: 0,
            zIndex: 48,
            background: "rgba(250,247,240,.98)",
            backdropFilter: "blur(8px)",
            padding: "10px 14px",
            overflowY: "auto",
          }}
        >
          {DATA.kapitoly.map((k, idx) => (
            <div
              key={k.id}
              className="menuLink"
              onClick={() => goto(k.id)}
              style={{
                display: "flex",
                alignItems: "baseline",
                gap: 14,
                padding: "16px 12px",
                borderRadius: 10,
                cursor: "pointer",
                borderBottom: `1px solid ${T.line}`,
              }}
            >
              <span
                style={{
                  fontFamily: HEAD,
                  color: T.gold,
                  fontWeight: 800,
                  fontSize: 16,
                  minWidth: 26,
                }}
              >
                {String(idx).padStart(2, "0")}
              </span>
              <span
                style={{
                  fontFamily: SANS,
                  fontSize: 17,
                  color: active === k.id ? T.green : T.ink,
                  fontWeight: active === k.id ? 700 : 500,
                }}
              >
                {k.nav}
              </span>
            </div>
          ))}
        </div>
      )}

      {/* ====================== ÚVOD / HERO ====================== */}
      <section
        id="uvod"
        style={{
          minHeight: "62svh",
          background: `radial-gradient(120% 90% at 50% -10%, ${T.green} 0%, ${T.greenDeep} 70%)`,
          color: "#fff",
          display: "flex",
          flexDirection: "column",
          justifyContent: "center",
          padding: "clamp(88px, 12vh, 110px) 22px clamp(48px, 7vh, 66px)",
          position: "relative",
          overflow: "hidden",
        }}
      >
        <div
          aria-hidden
          style={{
            position: "absolute",
            inset: 0,
            opacity: 0.06,
            backgroundImage:
              "repeating-linear-gradient(45deg, #fff 0 1px, transparent 1px 22px)",
          }}
        />
        <div
          style={{
            maxWidth: 760,
            margin: "0 auto",
            position: "relative",
            textAlign: "center",
          }}
        >
          <div
            style={{
              fontFamily: SANS,
              letterSpacing: 3,
              textTransform: "uppercase",
              color: T.gold,
              fontSize: 12.5,
              fontWeight: 700,
              marginBottom: 18,
            }}
          >
            Stanovisko bývalého člena představenstva
          </div>
          <h1
            style={{
              fontFamily: HEAD,
              fontWeight: 800,
              fontSize: "clamp(2rem, 8.5vw, 3.4rem)",
              lineHeight: 1.06,
              margin: 0,
            }}
          >
            k odstoupení z funkce
          </h1>
          <div
            style={{
              fontFamily: HEAD,
              fontStyle: "italic",
              fontWeight: 500,
              color: "#bcd0c4",
              fontSize: "clamp(1.15rem, 4.6vw, 1.8rem)",
              lineHeight: 1.2,
              marginTop: 10,
            }}
          >
            člena představenstva Bytového družstva Stará Role č. 1
          </div>
          <div
            style={{
              width: 70,
              height: 3,
              background: T.gold,
              margin: "22x auto",
            }}
          />
          <p
            style={{
              fontSize: "clamp(1.05rem, 4.6vw, 1.3rem)",
              color: "#d7e2da",
              lineHeight: 1.55,
              margin: "0 auto",
              maxWidth: 520,
            }}
          >
            Učinil jsem závažné rozhodnutí. Toto jsou hlavní důvody.
          </p>
          <div
            style={{
              fontFamily: SANS,
              marginTop: 28,
              color: "#9fb3a6",
              fontSize: 14.5,
            }}
          >
            <strong style={{ color: "#fff" }}>{DATA.autor}</strong>
            <br />
            {DATA.role}
          </div>
        </div>
        <div
          style={{
            position: "absolute",
            bottom: 16,
            left: 0,
            right: 0,
            textAlign: "center",
            fontFamily: SANS,
            color: "#8aa093",
            fontSize: 12.5,
          }}
        >
          ↓ posunout
        </div>
      </section>

      {/* ====================== ZBYTEK OBSAHU ====================== */}
      <Section id="proc">
        <Kicker n={1}>Východisko</Kicker>
        <H>Proč jsem vstoupil do představenstva</H>
        <P>
          V roce 2023 jsem vstoupil do představenstva s přesvědčením, že máme{" "}
          <strong style={{ color: T.ink }}>společnou vůli naplnit záměr</strong>
          , který je obsažen v našich smlouvách o vstupu do družstva:
        </P>
        <div
          style={{
            background: T.green,
            color: "#fff",
            borderRadius: 14,
            padding: "26px 24px",
            display: "flex",
            alignItems: "center",
            gap: 18,
            margin: "8px 0 22px",
          }}
        >
          <span style={{ fontSize: 34, lineHeight: 1 }}>🏠</span>
          <span
            style={{
              fontFamily: HEAD,
              fontWeight: 700,
              fontSize: "clamp(1.25rem, 5.4vw, 1.7rem)",
              lineHeight: 1.2,
            }}
          >
            Umožnit převod bytů do osobního vlastnictví členů
          </span>
        </div>
        <P
          style={{
            textAlign: "center",
            fontFamily: HEAD,
            fontStyle: "italic",
            color: T.red,
            fontWeight: 700,
            fontSize: "clamp(1.6rem, 8vw, 2.4rem)",
            margin: "26px 0",
            lineHeight: 1.15,
          }}
        >
          Mýlil jsem se.
          <span style={{ display: "block", fontSize: "0.62em", marginTop: 8 }}>
            Nevidím vůli naplnit smlouvy o vstupu do družstva.
          </span>
        </P>
        <Callout>
          <strong
            style={{
              color: T.green,
              fontFamily: SANS,
              fontSize: 12.5,
              letterSpacing: 0.6,
              textTransform: "uppercase",
              display: "block",
              marginBottom: 6,
            }}
          >
            Pro srovnání
          </strong>
          BD Stará Role č. 2 (naše sousední družstvo) bude byty převádět
          pravděpodobně již v září 2026 — po schválení zastupitelstvem města
          Karlovy Vary.
        </Callout>
        <RozborInline tlacitko="Co předcházelo mému vstupu do představenstva">
          <KontextVstup />
        </RozborInline>
        <Extras id="proc" />
      </Section>

      <Section id="duvody" max={760}>
        <Kicker n={2}>Přehled</Kicker>
        <H>Hlavní důvody odstoupení</H>
        <div style={{ display: "flex", flexDirection: "column", gap: 16 }}>
          {[
            {
              n: 1,
              h: "Ignorování závazku ze smluv o vstupu do družstva",
              t: "Smlouvy o vstupu (čl. 1.5 a čl. 8.1) obsahují záměr převést byty do vlastnictví členů a závazek zajistit prohlášení vlastníka. Dvacetiletá lhůta uplynula — nic se neděje.",
            },
            {
              n: 2,
              h: "Neplnění usnesení členské schůze o narovnání s městem",
              t: "Členská schůze uložila představenstvu dojednat narovnání podílu s městem. Uplynulo více než 10 měsíců — žádný krok nebyl učiněn.",
            },
            {
              n: 3,
              h: "Rozdílný pohled na plnění usnesení členské schůze k rozúčtování nákladů výstavby",
              t: "Usnesení z 28. 11. 2023 stanoví tři aspekty, které musí být zohledněny. Mám jiný názor na jejich naplnění.",
            },
          ].map((it) => (
            <div
              key={it.n}
              style={{
                display: "flex",
                gap: 18,
                background: T.card,
                border: `1px solid ${T.line}`,
                borderRadius: 14,
                padding: "20px 20px",
              }}
            >
              <div
                style={{
                  fontFamily: HEAD,
                  fontWeight: 800,
                  fontSize: 34,
                  color: T.gold,
                  lineHeight: 1,
                  flexShrink: 0,
                }}
              >
                {it.n}
              </div>
              <div>
                <div
                  style={{
                    fontFamily: HEAD,
                    fontWeight: 700,
                    color: T.ink,
                    fontSize: "1.2rem",
                    marginBottom: 6,
                  }}
                >
                  {it.h}
                </div>
                <div style={{ lineHeight: 1.6 }}>{it.t}</div>
              </div>
            </div>
          ))}
        </div>
        <Extras id="duvody" />
      </Section>

      <Section id="duvod1">
        <Kicker n={3}>Důvod 1</Kicker>
        <H>Ignorování závazku ze smluv o vstupu do družstva</H>
        <P>
          Všichni jsme do družstva vstupovali s vědomím, že bude naplněn záměr
          převodu bytů do osobního vlastnictví členů. Tento záměr — i konkrétní
          povinnost a lhůta k jeho naplnění — nestojí jen na ústním příslibu: je
          výslovně zakotven přímo ve smlouvách o vstupu do družstva.
        </P>
        <div style={{ display: "flex", flexDirection: "column", gap: 14 }}>
          <div
            style={{
              background: T.greenSoft,
              borderRadius: 12,
              padding: "18px 20px",
            }}
          >
            <div
              style={{
                fontFamily: SANS,
                fontWeight: 700,
                color: T.green,
                marginBottom: 8,
              }}
            >
              Článek 1.5 — Záměr
            </div>
            <div style={{ fontStyle: "italic", lineHeight: 1.75 }}>
              „Strany této smlouvy{" "}
              <Mark>
                deklarují společný záměr v budoucnu uskutečnit vlastnický převod
                bytové jednotky
              </Mark>
              , k ní neoddělitelně náležejícího a podle ustanovení § 8 odst. 2
              zákona čís.: 72/1994 Sb. určeného spoluvlastnického podílu na
              společných částech domu, jakož i na pozemcích, na nichž dům stojí,
              tedy té bytové jednotky, s níž je nyní spojeno právo nájmu bytu
              svědčící ve prospěch budoucího nájemce a označené v půdorysech
              domu, tvořících přílohu č. 5 této smlouvy, a to{" "}
              <Mark>
                z podílového spoluvlastnictví Družstva a Města do výlučného
                vlastnictví budoucího nájemce
              </Mark>
              .“
            </div>
          </div>
          <div
            style={{
              background: T.greenSoft,
              borderRadius: 12,
              padding: "18px 20px",
            }}
          >
            <div
              style={{
                fontFamily: SANS,
                fontWeight: 700,
                color: T.green,
                marginBottom: 8,
              }}
            >
              Článek 8.1 — Povinnost a lhůta
            </div>
            <div style={{ fontStyle: "italic", lineHeight: 1.75 }}>
              „Budoucí pronajímatelé se touto smlouvou <Mark>zavazují</Mark>, že{" "}
              <Mark>
                bez zbytečného odkladu po uplynutí lhůty 20 let ode dne právní
                moci kolaudačního rozhodnutí
              </Mark>{" "}
              na bytové domy{" "}
              <Mark>zajistí platné rozdělení bytových domů na jednotky</Mark>{" "}
              podle zák. č. 72/1994 Sb. spolu s příslušnými spoluvlastnickými
              podíly ke společným částem domu a příslušným zastavěným pozemkům a
              pozemkům k budově přínáležejícím.“
            </div>
          </div>
        </div>
        <div style={{ marginTop: 16 }}>
          <Callout tone="note">
            <strong style={{ color: T.ink }}>Jednoduše:</strong> Smlouvy od
            počátku deklarují záměr převést jednotky do vašeho vlastnictví.
            Lhůta 20 let už uplynula.
          </Callout>
        </div>
        <div style={{ marginTop: 14 }}>
          <Callout tone="danger">
            ⚠️ Představenstvo nezahájilo žádné kroky k rozdělení domů na
            jednotky.
          </Callout>
        </div>
        <P style={{ marginTop: 22 }}>
          O těchto povinnostech i o samotném záměru převodu bytů jsem
          představenstvo a kontrolní komisi opakovaně písemně informoval. Mé
          výzvy si můžete přečíst v plném znění zde:
        </P>
        <Extras id="duvod1" />
      </Section>

      <Section id="duvod2">
        <Kicker n={4}>Důvod 2</Kicker>
        <H>Neplnění usnesení členské schůze</H>
        <P>
          Členská schůze konaná 23. 6. 2025 uložila představenstvu dojednat s
          Městem Karlovy Vary odpovídající převod majetku (narovnání stávajícího
          vlastnického poměru) a plnit následující termíny:
        </P>
        <div
          style={{
            fontFamily: SANS,
            fontWeight: 700,
            color: T.ink,
            margin: "6px 0 12px",
          }}
        >
          Termíny schválené členskou schůzí
        </div>
        <div style={{ display: "flex", flexDirection: "column", gap: 10 }}>
          {[
            {
              d: "Červenec 2025",
              t: "Odeslání přehledu příjmů členům",
              late: true,
            },
            {
              d: "Listopad 2025",
              t: "Finální rozúčtování nákladů výstavby",
              late: true,
            },
            {
              d: "Červen 2026",
              t: "Sdělení stavu narovnání — neproběhlo žádné jednání",
              late: false,
            },
            {
              d: "Prosinec 2026",
              t: "Dokončení narovnání vlastnického poměru",
              late: false,
            },
          ].map((r, i) => (
            <div
              key={i}
              style={{
                display: "flex",
                gap: 14,
                alignItems: "flex-start",
                background: r.late ? T.redSoft : "#f1efe7",
                borderRadius: 10,
                padding: "14px 16px",
              }}
            >
              <span style={{ fontSize: 17, flexShrink: 0, marginTop: 1 }}>
                {r.late ? "❌" : "⏳"}
              </span>
              <div style={{ flex: 1 }}>
                <div
                  style={{
                    display: "flex",
                    alignItems: "center",
                    gap: 10,
                    flexWrap: "wrap",
                  }}
                >
                  <span
                    style={{
                      fontFamily: SANS,
                      fontWeight: 700,
                      color: r.late ? T.red : T.ink,
                    }}
                  >
                    {r.d}
                  </span>
                  {r.late && (
                    <span
                      style={{
                        fontFamily: SANS,
                        fontWeight: 700,
                        fontSize: 11,
                        letterSpacing: 0.5,
                        textTransform: "uppercase",
                        color: "#fff",
                        background: T.red,
                        padding: "2px 9px",
                        borderRadius: 20,
                      }}
                    >
                      Nesplněno
                    </span>
                  )}
                </div>
                <div
                  style={{ lineHeight: 1.5, color: T.body, fontSize: ".98rem" }}
                >
                  {r.t}
                </div>
              </div>
            </div>
          ))}
        </div>
        <Extras id="duvod2" />
      </Section>

      <Section id="duvod3" max={760}>
        <Kicker n={5}>Důvod 3</Kicker>
        <H>Rozdílný pohled na plnění usnesení členské schůze</H>
        <P>
          Členská schůze schválila, že při rozúčtování nákladů výstavby budou
          zohledněny tyto tři aspekty:
        </P>
        <Duvod3Cards />
        <Callout tone="danger">
          ⚠️ Představenstvo nemá právo usnesení modifikovat nebo svévolně
          redukovat parametry, na kterých se členská schůze platně usnesla.
        </Callout>
        <Extras id="duvod3" />
      </Section>

      <Section id="plocha" max={760}>
        <Kicker n={6}>Aspekt 1 podrobně</Kicker>
        <H>Pronajatá plocha: dopad na garáže a sklepy</H>
        <P>
          Smlouvy o vstupu stanovily různé ceny za m² pro byty, sklepy a garáže.
          Nový výpočet je sjednocuje na jednu sazbu — to nepřiměřeně dopadá
          zejména na garáže:
        </P>
        <ResponsiveCompare />
        <div style={{ marginTop: 18 }}>
          <Callout tone="note">
            <strong style={{ color: T.ink }}>Jednoduše:</strong> Pokud jste
            koupili garáž za 12 978 Kč/m², nový výpočet vám ji zpětně přecení na
            18 875 Kč/m² (to je navýšení o 5 897 Kč/m²). Přitom u bytů nárůst činí jen 895 Kč/m². Takové jednostranné
            přecenění narušuje vaše legitimní očekávání.
          </Callout>
        </div>
        <Law>
          § 212 odst. 1 NOZ: Korporace nesmí svého člena bezdůvodně zvýhodňovat
          ani znevýhodňovat.
        </Law>
        <RozborInline tlacitko="Porušení zásady rovného zacházení">
          <RozborPlocha />
        </RozborInline>
        <Extras id="plocha" />
      </Section>

      <Section id="uver" max={820}>
        <Kicker n={7}>Aspekt 2 podrobně</Kicker>
        <H>Míra využití úvěru: co to vlastně znamená?</H>
        <div
          style={{
            display: "grid",
            gridTemplateColumns: "repeat(auto-fit, minmax(270px, 1fr))",
            gap: 16,
          }}
        >
          <div
            style={{
              background: T.redSoft,
              borderRadius: 14,
              padding: "22px 22px",
            }}
          >
            <div
              style={{
                fontFamily: SANS,
                fontWeight: 700,
                color: T.red,
                marginBottom: 12,
                display: "flex",
                gap: 8,
                alignItems: "center",
              }}
            >
              <span>❌</span> Výklad ostatních
            </div>
            <div
              style={{
                fontFamily: HEAD,
                fontWeight: 700,
                color: T.ink,
                marginBottom: 8,
              }}
            >
              „Míra“ = počet roků
            </div>
            <div style={{ fontWeight: 600, marginBottom: 8 }}>
              Mimořádné splátky se nezohledňují.
            </div>
            <div style={{ lineHeight: 1.6, fontSize: ".98rem" }}>
              Člen, který splatil např. 1/3 jistiny mimořádnou splátkou v roce
              2010, platí stejné úroky jako člen, který neučinil žádnou
              mimořádnou splátku.
            </div>
          </div>
          <div
            style={{
              background: T.okSoft,
              borderRadius: 14,
              padding: "22px 22px",
            }}
          >
            <div
              style={{
                fontFamily: SANS,
                fontWeight: 700,
                color: T.ok,
                marginBottom: 12,
                display: "flex",
                gap: 8,
                alignItems: "center",
              }}
            >
              <span>✅</span> Můj výklad
            </div>
            <div
              style={{
                fontFamily: HEAD,
                fontWeight: 700,
                color: T.ink,
                marginBottom: 8,
              }}
            >
              „Míra“ = kolik a jak dlouho
            </div>
            <div style={{ fontWeight: 600, marginBottom: 8 }}>
              Mimořádné splátky snižují jistinu.
            </div>
            <div style={{ lineHeight: 1.6, fontSize: ".98rem" }}>
              Kdo zaplatil mimořádnou splátku, ten zatížil úvěr méně — a má platit menší podíl
              na úrocích. Tak to funguje i v bance.
            </div>
          </div>
        </div>
        <div style={{ marginTop: 18 }}>
          <Callout tone="note">
            <strong style={{ color: T.ink }}>Jednoduše:</strong> Družstvo
            přijímalo vaše mimořádné splátky. Z logiky smluvního vztahu plyne,
            že se tím sníží váš zůstatek jistiny — a tedy se i přepočítají
            úroky. Ignorovat to je nespravedlivé.
          </Callout>
        </div>
        <Law>
          § 555 NOZ: Právní jednání se posuzuje podle svého obsahu. „Míra“ ≠
          „počet roků“.
        </Law>
        <RozborInline tlacitko="Porušení dobrých mravů">
          <RozborUver />
        </RozborInline>
        <Extras id="uver" />
      </Section>

      <Section id="moralka" max={820}>
        <Kicker n={8}>Aspekt 3 podrobně</Kicker>
        <H>Platební morálka: proč ji nelze vynechat</H>
        <P>
          Třetím aspektem, který členská schůze uložila zohlednit, je platební
          morálka — tedy zda člen plnil své platební povinnosti řádně
          a včas. Vypadá to, že představenstva je nezohlední. Proč je to
          problém?
        </P>
        <div
          style={{
            display: "grid",
            gridTemplateColumns: "repeat(auto-fit, minmax(270px, 1fr))",
            gap: 16,
          }}
        >
          <div
            style={{
              background: T.redSoft,
              borderRadius: 14,
              padding: "22px 22px",
            }}
          >
            <div
              style={{
                fontFamily: SANS,
                fontWeight: 700,
                color: T.red,
                marginBottom: 12,
                display: "flex",
                gap: 8,
                alignItems: "center",
              }}
            >
              <span>❌</span> Když se nezohlední
            </div>
            <div
              style={{
                fontFamily: HEAD,
                fontWeight: 700,
                color: T.ink,
                marginBottom: 8,
              }}
            >
              Všichni platí stejně
            </div>
            <div style={{ fontWeight: 600, marginBottom: 8 }}>
              Opožděné platby se ignorují.
            </div>
            <div style={{ lineHeight: 1.6, fontSize: ".98rem" }}>
              Člen, který platil řádně a včas, nese stejný podíl na úrocích jako
              člen, který se opožďoval nebo neplnil svou platební povinnost.
            </div>
          </div>
          <div
            style={{
              background: T.okSoft,
              borderRadius: 14,
              padding: "22px 22px",
            }}
          >
            <div
              style={{
                fontFamily: SANS,
                fontWeight: 700,
                color: T.ok,
                marginBottom: 12,
                display: "flex",
                gap: 8,
                alignItems: "center",
              }}
            >
              <span>✅</span> Když se zohlední
            </div>
            <div
              style={{
                fontFamily: HEAD,
                fontWeight: 700,
                color: T.ink,
                marginBottom: 8,
              }}
            >
              Platí ten, kdo zdržení způsobil
            </div>
            <div style={{ fontWeight: 600, marginBottom: 8 }}>
              Opožděné platby zvyšují úrokovou zátěž.
            </div>
            <div style={{ lineHeight: 1.6, fontSize: ".98rem" }}>
              Kdo neplatil včas, prodloužil čerpání úvěru a způsobil vyšší úroky
              — má proto nést větší podíl na úrocích, ne jej přenášet na
              ostatní.
            </div>
          </div>
        </div>
        <div style={{ marginTop: 18 }}>
          <Callout tone="note">
            <strong style={{ color: T.ink }}>Jednoduše:</strong> Kdo platil
            poctivě a včas, nemá doplácet na toho, kdo se opožďoval. Vynechat
            platební morálku znamená přenést náklady zpoždění na ukázněné členy
            — a navíc nesplnit aspekt, který členská schůze výslovně uložila.
          </Callout>
        </div>
        <Law>
          § 706 odst. 2 ZOK: Představenstvo plní usnesení členské schůze. § 212
          odst. 1 NOZ a § 575 ZOK: korporace nesmí svého člena bezdůvodně
          zvýhodňovat ani znevýhodňovat.
        </Law>
        <RozborInline tlacitko="Nelze si vybírat části usnesení">
          <RozborMoralka />
        </RozborInline>
        <Extras id="moralka" />
      </Section>

      <Section id="shrnuti">
        <Kicker n={9}>Shrnutí</Kicker>
        <H>Celé usnesení, nebo nic</H>
        <div
          style={{
            background: T.card,
            border: `1px solid ${T.line}`,
            borderTop: `4px solid ${T.red}`,
            borderRadius: 14,
            padding: "26px 24px",
          }}
        >
          <p
            style={{
              fontFamily: HEAD,
              fontWeight: 700,
              color: T.red,
              fontSize: "clamp(1.25rem, 5.6vw, 1.6rem)",
              lineHeight: 1.3,
              margin: "0 0 12px",
            }}
          >
            Představenstvo si nemůže selektivně vybrat, co naplní z usnesení
            členské schůze.
          </p>
          <p style={{ fontWeight: 600, color: T.ink, margin: "0 0 18px" }}>
            Musí naplnit celé usnesení — všechny tři aspekty.
          </p>
          <p style={{ margin: "0 0 10px" }}>
            Zároveň musí dodržovat základní právní zásady:
          </p>
          <ul style={{ margin: 0, paddingLeft: 22, lineHeight: 1.8 }}>
            <li>Smlouvy se mají dodržovat</li>
            <li>Legitimní očekávání členů musí být chráněno</li>
            <li>Členové nesmí být bezdůvodně znevýhodňováni</li>
          </ul>
        </div>
        <Extras id="shrnuti" />
      </Section>

      <section
        id="zaver"
        style={{
          background: `linear-gradient(180deg, ${T.green}, ${T.greenDeep})`,
          color: "#fff",
          padding: "clamp(70px,16vw,130px) 22px",
        }}
      >
        <div style={{ maxWidth: 720, margin: "0 auto", textAlign: "center" }}>
          <h2
            style={{
              fontFamily: HEAD,
              fontWeight: 800,
              fontSize: "clamp(2rem, 9vw, 3.4rem)",
              lineHeight: 1.05,
              margin: 0,
            }}
          >
            Nechci se podílet
          </h2>
          <p
            style={{
              fontSize: "clamp(1.08rem, 5vw, 1.4rem)",
              color: "#cfdcd3",
              lineHeight: 1.55,
              marginTop: 18,
            }}
          >
            na rozhodnutích, s kterými bytostně nesouhlasím a kde mi každá buňka
            v těle říká, že jsou nespravedlivá a v rozporu se záměrem, s
            kterým družstvo vzniklo.
          </p>
          <div
            style={{
              width: 70,
              height: 1,
              background: "#5f7a6c",
              margin: "34px auto",
            }}
          />
          <p
            style={{
              fontFamily: HEAD,
              fontStyle: "italic",
              fontSize: "clamp(1.3rem, 6vw, 1.9rem)",
              margin: "0 0 8px",
            }}
          >
            Děkuji za pozornost.
          </p>
          <p style={{ fontFamily: SANS, color: "#9fb3a6", fontSize: 15 }}>
            {DATA.autor}
          </p>
          <Extras id="zaver" />
        </div>
      </section>

      <footer
        style={{
          background: T.greenDeep,
          color: "#8aa093",
          fontFamily: SANS,
          fontSize: 13,
          textAlign: "center",
          padding: "26px 22px",
        }}
      >
        {DATA.brand} · člena BD Stará Role č. 1 · {DATA.autor}
      </footer>
    </div>
  );
}

function ResponsiveCompare() {
  const data = [
    { name: "Byt", smluvni: "17 980 Kč", po: "18 875 Kč", inc: "5 %", c: T.ok },
    {
      name: "Sklep",
      smluvni: "15 070 Kč",
      po: "18 875 Kč",
      inc: "25 %",
      c: T.gold,
    },
    {
      name: "Garáž",
      smluvni: "12 978 Kč",
      po: "18 875 Kč",
      inc: "45 %",
      c: T.red,
    },
  ];
  return (
    <div
      style={{
        display: "grid",
        gridTemplateColumns: "repeat(auto-fit, minmax(150px, 1fr))",
        gap: 14,
      }}
    >
      {data.map((d) => (
        <div
          key={d.name}
          style={{
            background: T.card,
            border: `1px solid ${T.line}`,
            borderRadius: 14,
            overflow: "hidden",
          }}
        >
          <div
            style={{
              background: T.green,
              color: "#fff",
              fontFamily: HEAD,
              fontWeight: 700,
              fontSize: "1.15rem",
              padding: "12px 16px",
              textAlign: "center",
            }}
          >
            {d.name}
          </div>
          <div style={{ padding: "16px" }}>
            <Row label="Smluvní cena/m²" v={d.smluvni} />
            <Row label="Po rozpočítání/m²" v={d.po} />
            <div
              style={{
                borderTop: `1px solid ${T.line}`,
                marginTop: 12,
                paddingTop: 12,
                textAlign: "center",
              }}
            >
              <div
                style={{
                  fontFamily: SANS,
                  fontSize: 12,
                  color: T.muted,
                  textTransform: "uppercase",
                  letterSpacing: 0.6,
                }}
              >
                Navýšení
              </div>
              <div
                style={{
                  fontFamily: HEAD,
                  fontWeight: 800,
                  fontSize: "2rem",
                  color: d.c,
                  lineHeight: 1.1,
                }}
              >
                {d.inc}
              </div>
            </div>
          </div>
        </div>
      ))}
    </div>
  );
}
const Row = ({ label, v }: { label: string; v: string }) => (
  <div
    style={{
      display: "flex",
      justifyContent: "space-between",
      gap: 10,
      padding: "4px 0",
      fontFamily: SANS,
      fontSize: 14,
    }}
  >
    <span style={{ color: T.muted }}>{label}</span>
    <span style={{ color: T.ink, fontWeight: 600, whiteSpace: "nowrap" }}>
      {v}
    </span>
  </div>
);

function Duvod3Cards() {
  const [openCard, setOpenCard] = useState<number | null>(null);
  const cards = [
    {
      n: 1,
      t: "Pronajatá plocha",
      b: "Problém",
      d: "Sjednocení ceny za m² mění smluvní podmínky",
      rozbor: true,
      tlacitko: "Porušení zásady rovného zacházení",
    },
    {
      n: 2,
      t: "Míra využití družstevního úvěru",
      b: "Problém",
      d: "Ignoruje mimořádné splátky členů",
      rozbor: true,
      tlacitko: "Porušení dobrých mravů",
    },
    {
      n: 3,
      t: "Platební morálka",
      b: "Odmítnuto",
      d: "Vypadá to, že představenstvo ji nezohlední",
      rozbor: true,
      tlacitko: "Nelze si vybírat části usnesení",
    },
  ];
  const toggle = (n: number) => setOpenCard((cur) => (cur === n ? null : n));

  return (
    <div style={{ marginBottom: 20 }}>
      <div
        style={{
          display: "grid",
          gridTemplateColumns: "repeat(auto-fit, minmax(210px, 1fr))",
          gap: 14,
        }}
      >
        {cards.map((c) => (
          <div
            key={c.n}
            style={{
              background: T.card,
              border: `1px solid ${openCard === c.n ? T.gold : T.line}`,
              borderRadius: 14,
              padding: "22px 18px",
              textAlign: "center",
              display: "flex",
              flexDirection: "column",
              transition: "border-color .2s",
            }}
          >
            <div
              style={{
                fontFamily: HEAD,
                fontWeight: 800,
                fontSize: 40,
                color: T.gold,
                lineHeight: 1,
              }}
            >
              {c.n}
            </div>
            <div
              style={{
                fontFamily: HEAD,
                fontWeight: 700,
                color: T.ink,
                fontSize: "1.08rem",
                margin: "8px 0 12px",
                lineHeight: 1.25,
              }}
            >
              {c.t}
            </div>
            <div
              style={{
                display: "inline-block",
                background: T.redSoft,
                color: T.red,
                fontFamily: SANS,
                fontWeight: 700,
                fontSize: 13,
                padding: "5px 14px",
                borderRadius: 20,
                alignSelf: "center",
              }}
            >
              {c.b}
            </div>
            <div
              style={{
                color: T.muted,
                fontSize: ".92rem",
                lineHeight: 1.45,
                marginTop: 12,
                flex: 1,
              }}
            >
              {c.d}
            </div>
            {c.rozbor && (
              <button
                onClick={() => toggle(c.n)}
                aria-expanded={openCard === c.n}
                style={{
                  all: "unset",
                  cursor: "pointer",
                  marginTop: 16,
                  fontFamily: SANS,
                  fontWeight: 700,
                  fontSize: 13.5,
                  color: T.green,
                  borderTop: `1px solid ${T.line}`,
                  paddingTop: 12,
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "center",
                  gap: 6,
                  minHeight: 24,
                }}
              >
                {c.tlacitko}{" "}
                <span
                  style={{
                    transition: "transform .2s",
                    transform: openCard === c.n ? "rotate(180deg)" : "none",
                  }}
                >
                  ▾
                </span>
              </button>
            )}
          </div>
        ))}
      </div>

      {openCard === 1 && <RozborPlocha />}
      {openCard === 2 && <RozborUver />}
      {openCard === 3 && <RozborMoralka />}
    </div>
  );
}

const RozborBox = ({
  kicker,
  nadpis,
  children,
}: {
  kicker: string;
  nadpis: string;
  children: ReactNode;
}) => (
  <div
    className="rozborIn"
    style={{
      marginTop: 16,
      background: T.card,
      border: `1px solid ${T.line}`,
      borderLeft: `4px solid ${T.gold}`,
      borderRadius: 12,
      padding: "24px 24px",
    }}
  >
    <div
      style={{
        fontFamily: SANS,
        fontSize: 11.5,
        letterSpacing: 1,
        textTransform: "uppercase",
        color: T.gold,
        fontWeight: 700,
        marginBottom: 8,
      }}
    >
      {kicker}
    </div>
    <h3
      style={{
        fontFamily: HEAD,
        fontWeight: 700,
        color: T.ink,
        fontSize: "1.4rem",
        margin: "0 0 16px",
        lineHeight: 1.2,
      }}
    >
      {nadpis}
    </h3>
    <div style={{ color: T.body, lineHeight: 1.7, fontSize: "1.02rem" }}>
      {children}
    </div>
  </div>
);
const RozborH = ({ children }: { children: ReactNode }) => (
  <h4
    style={{
      fontFamily: SANS,
      fontWeight: 700,
      color: T.green,
      fontSize: "1.02rem",
      margin: "0 0 .5em",
    }}
  >
    {children}
  </h4>
);

function RozborPlocha() {
  return (
    <RozborBox
      kicker="Pronajatá plocha"
      nadpis="Porušení zásady rovného zacházení"
    >
      <p style={{ margin: "0 0 1em" }}>
        Družstvo je povinno zacházet se všemi svými členy za stejných podmínek
        stejně. Jakékoli rozdílné zacházení musí být objektivně a spravedlivě
        odůvodněno a musí vyplývat ze stanov družstva, smluv o vstupu do
        družstva anebo právních předpisů. Zavedení rozdílného navýšení
        „nabídkové ceny“ při vstupu do družstva za m² u různých prostor (byt,
        sklep a garáž) představuje{" "}
        <Mark>neodůvodněné znevýhodnění části členů</Mark> oproti ostatním a
        zakládá nerovné zacházení. Aby bylo různé navýšení právně obhajitelné,
        muselo by představenstvo disponovat např. znaleckým posudkem, který
        prokáže, že náklady na jejich výstavbu byly oproti jiným prostorům
        vyšší.
      </p>
      <p style={{ margin: "0 0 1em" }}>
        Zásada rovného zacházení (
        <strong style={{ color: T.ink }}>§ 212 NOZ</strong>) neznamená, že
        všichni členové musí platit stejnou absolutní částku za m² jakéhokoliv
        prostoru, ale že rozdíly v zacházení musí být založeny na objektivních a
        racionálních kritériích a nesmí být svévolné. Když členové v roce 2005
        „kupovali“ např. garáže, byla jejich hodnota ve smlouvě o vstupu do
        družstva stanovena smluvně. Pokud tehdy byla stanovena fixně, je to
        součást zásady <em>pacta sunt servanda</em> (smlouvy se mají dodržovat).
        Pokud členové nabyli garáže za specifických smluvních podmínek, nemůže
        družstvo jednostranně změnit základní finanční rovnici tohoto uspořádání
        bez souhlasu člena; tím narušuje jeho <Mark>legitimní očekávání</Mark>.
      </p>
      <p style={{ margin: 0 }}>
        Navrhované navýšení „ceny“ za garáže o cca 40 %, v kontrastu s výrazně
        menším navýšením u bytových jednotek, vyvolává důvodné podezření z
        porušení <Mark>zásady rovného zacházení</Mark> (§ 212 NOZ). Pokud je
        navýšení způsobeno jen tím, že se mění klíč rozpočítání společných
        nákladů v neprospěch členů s garáží, je usnesení napadnutelné pro rozpor
        s dobrými mravy a soud by jej s vysokou pravděpodobností zrušil.
      </p>
    </RozborBox>
  );
}

function RozborUver() {
  return (
    <RozborBox
      kicker="Míra využití úvěru"
      nadpis="Mimořádné splátky členů jsou fakt — mají být zohledněny"
    >
      <p style={{ margin: "0 0 1.4em" }}>
        Družstvo umožňovalo svým členům provádět mimořádné splátky — přijímalo
        je a evidovalo. Z logiky smluvního vztahu plyne, že{" "}
        <Mark>
          mimořádnou splátkou se sníží zbývající jistina, a tím i budoucí úroky
        </Mark>
        . Jiný důvod pro mimořádné splátky prakticky neexistuje. Tento fakt mám
        za nesporný.
      </p>
      <p style={{ margin: "0 0 1em" }}>
        Představenstvo je při volbě metody rozpočítání úroků vázáno obecnými
        právními principy — zásadou rovného zacházení s členy družstva a
        ochranou jejich dobré víry. Rovné zacházení neznamená „všem stejně“.
        Znamená
        <Mark>„stejným stejně, odlišným odlišně“</Mark>. Členové, kteří z úvěru
        reálně čerpali různě, jsou v odlišné situaci. Metoda, která s nimi
        zachází stejně, není spravedlivá — je pouze formálně rovná.
      </p>
      <p style={{ margin: "0 0 1.4em" }}>
        Člen, který provedl mimořádnou splátku, jednal v důvěře, že tato splátka
        sníží jeho úrokové zatížení. Tato důvěra nebyla bezdůvodná — vyplývala z
        logiky smluvního vztahu i z praxe družstva. Metoda, která tuto důvěru
        retroaktivně popře, porušuje ochranu dobré víry. Metoda nezohledňující
        reálné platby oba tyto principy porušuje: s reálným průběhem čerpání
        úvěru nepočítá a výsledkem je{" "}
        <Mark>bezdůvodný přesun úroků mezi členy</Mark>.
      </p>
      <p style={{ margin: "0 0 1em" }}>
        Nemohu podpořit metodu, která ignoruje skutečné platby členů a popírá
        logiku, na které celý systém mimořádných splátek stojí. Nedokážu se
        podívat do očí členům tohoto družstva a říci jim, že na rozložení jejich
        skutečných plateb nezáleží.
      </p>
      <p style={{ margin: 0 }}>
        Použití metody nezohledňující reálné platby při implementaci usnesení
        členské schůze konané 28. 11. 2023 navíc hrozí tím, že 
        může být posouzena jako <Mark>příčící se dobrým mravům</Mark> — zejména
        v kontextu případného civilního sporu s konkrétním členem družstva. Moje
        stanovisko je právní i morální.
      </p>
    </RozborBox>
  );
}

function RozborMoralka() {
  return (
    <RozborBox
      kicker="Platební morálka · proč ji nelze vynechat"
      nadpis="Představenstvo nesmí vynechat ani jeden aspekt"
    >
      <p style={{ margin: "0 0 1em" }}>
        Členská schůze dne 28. 11. 2023 uložila, že se při rozúčtování zohlední
        tři aspekty — pronajatá plocha, míra využití úvěru a platební morálka.
        Tento výčet je <Mark>úplný a kumulativní</Mark>: usnesení neobsahuje
        žádnou formulaci typu „některý z" nebo „dle uvážení představenstva".
      </p>
      <p style={{ margin: "0 0 1em" }}>
        Usnesení nejvyššího orgánu je pro představenstvo závazné a
        představenstvo z něj nesmí vybírat ani jej zužovat. Odmítnutí zohlednit
        platební morálku proto{" "}
        <Mark>není výkladem usnesení — je jeho porušením</Mark>.
      </p>
      <p style={{ margin: 0 }}>
        Věcně jde o disciplinární rozměr rozúčtování — zda člen platil řádně a
        včas. Když se nezohlední, nese stejný díl ten, kdo plnil poctivě, i ten,
        kdo se opožďoval. To{" "}
        <Mark>bezdůvodně znevýhodňuje řádně platící členy</Mark>.
      </p>
    </RozborBox>
  );
}

function KontextVstup() {
  return (
    <RozborBox
      kicker="Kontext"
      nadpis="Co předcházelo mému vstupu do představenstva"
    >
      <RozborH>Podzim 2022 — krize v představenstvu</RozborH>
      <p style={{ margin: "0 0 1em" }}>
        Předseda družstva pan Pinkas bez vědomí ostatních členů představenstva
        nebo kontrolní komise převedl na svůj účet prostředky družstva ve výši
        několika milionů korun. Tyto prostředky později vrátil na účet družstva.
        Podle vyjádření právního zástupce ke škodě na majetku družstva nedošlo.
      </p>
      <p style={{ margin: "0 0 1.4em" }}>
        Představenstvo mělo taktéž rozpory při řešení tří zásadních otázek — způsobu
        výběru splátek členských vkladů, refinancování družstevního úvěru a
        nakládání s volnými prostředky družstva. Spory se nepodařilo překlenout
        ani za účasti kontrolní komise, a proto byly přeneseny na náhradní
        členskou schůzi konanou 29. 11. 2022. Na této schůzi reginoval člen představenstva pan Hejda.
      </p>

      <RozborH>Náhradní členská schůze 24. 1. 2023</RozborH>
      <p style={{ margin: "0 0 1em" }}>
        Skupina členů družstva navrhla odvolání předsedy představenstva. Hlasování pro
        odvolání nezískalo většinu všech přítomných členů.
      </p>
      <p style={{ margin: "0 0 1em" }}>
        Na schůzi členka družstva vznesla dotaz, zda by člen představenstva pan
        Hejda (přestože v listopadu rezignoval) mohl za přispění této členské
        schůze nějak pokračovat ve funkci. JUDr. Maglia odpověděl, že rezignaci
        nelze vzít zpět a{" "}
        <Mark>
          pan Hejda dokonce na této členské schůzi ani nemůže být kandidátem,
          neboť je stále platným členem představenstva
        </Mark>
        .
      </p>
      <p style={{ margin: "0 0 1em" }}>
        <Mark>
          Zpětně tento právní názor hodnotím jako velmi radikální — členové
          představenstva jsou běžně znovuzvoleni do funkce, aniž by nejprve
          odstupovali; to znamená, že v době volby jsou stále platnými členy představenstva.
        </Mark>{" "}
        Případně mohlo být při volbě upřesněno, že výkon funkce začíná prvním
        dnem po skončení původního mandátu.
      </p>
      <p style={{ margin: "0 0 1.4em" }}>
        Poté jsem kandidoval; získal jsem 55 hlasů z přítomných, avšak protože
        odvolání předsedy nebylo platné a představenstvo bylo v tu chvíli plně
        obsazené, nebyl jsem na této schůzi zvolen.
      </p>

      <RozborH>Počátek února 2023 — kooptace</RozborH>
      <p style={{ margin: 0 }}>
        Krátce poté jsem byl do představenstva kooptován. Vstupoval jsem do něj
        s přesvědčením, že máme
        <Mark>
          společnou vůli naplnit záměr převodu bytů do osobního vlastnictví
          členů
        </Mark>
        .
      </p>
    </RozborBox>
  );
}

function RozborInline({
  tlacitko,
  children,
}: {
  tlacitko: string;
  children: ReactNode;
}) {
  const [open, setOpen] = useState<boolean>(false);
  return (
    <div style={{ marginTop: 26 }}>
      <button
        onClick={() => setOpen((o) => !o)}
        aria-expanded={open}
        style={{
          all: "unset",
          boxSizing: "border-box",
          cursor: "pointer",
          width: "100%",
          display: "flex",
          alignItems: "center",
          gap: 12,
          padding: "14px 18px",
          minHeight: 54,
          background: "#fff",
          border: `1px solid ${open ? T.gold : T.line}`,
          borderLeft: `3px solid ${T.gold}`,
          borderRadius: 10,
          transition: "border-color .2s",
        }}
      >
        <span
          style={{
            flex: 1,
            fontFamily: SANS,
            fontWeight: 700,
            color: T.green,
            fontSize: 15,
          }}
        >
          {tlacitko}
        </span>
        <span style={{ fontFamily: SANS, color: T.muted, fontSize: 13 }}>
          {open ? "Skrýt" : "Rozbalit"}
        </span>
        <span
          style={{
            color: T.green,
            transition: "transform .2s",
            transform: open ? "rotate(180deg)" : "none",
          }}
        >
          ▾
        </span>
      </button>
      {open && children}
    </div>
  );
}
